import { money, pc, xx } from "../../lib/casePath";

export const ST = {
  cumple: ["Cumple", "bg-emerald-500", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  alerta: ["Alerta", "bg-amber-400", "bg-amber-50 text-amber-800 border-amber-200"],
  incumple: ["Incumple", "bg-rose-500", "bg-rose-50 text-rose-800 border-rose-200"],
  sin_datos: ["Sin datos", "bg-[#C9C3B8]", "bg-[#F2F0EC] text-[#5C5850] border-[#E2DDD5]"],
  dispensa: ["Dispensa", "bg-sky-500", "bg-sky-50 text-sky-800 border-sky-200"],
};
export const FLAG = {
  periodo_cura: ["Periodo de cura", "bg-amber-100 text-amber-900"],
  step_up: ["Step-up +300 pb", "bg-orange-200 text-orange-900"],
  vencimiento_anticipado: ["Causa de vencimiento anticipado", "bg-rose-600 text-white"],
};
export const CAMPOS = [
  ["ingresos", "Ingresos facturados"], ["depositos", "Depósitos en cuentas Trafalgar"], ["uafirda", "UAFIRDA del mes"], ["isr", "ISR del mes"],
  ["servicio_deuda", "Servicio de deuda"], ["aportacion_fondo", "Aportación al fondo de reserva"], ["deuda_financiera", "Deuda financiera (saldo)"],
  ["dividendos", "Dividendos pagados"], ["prestamos_pr", "Préstamos a partes relacionadas (saldo)"],
];
export const INFO = [["eeff", "EEFF del periodo"], ["balanza", "Balanza de comprobación"], ["declaracion", "Declaración anual"], ["opinion32d", "Opinión 32-D positiva"]];

export const Dot = ({ s, title, testid }) => <span title={title} data-testid={testid} className={`inline-block h-3 w-3 rounded-full ${ST[s]?.[1] || "bg-[#C9C3B8]"}`} />;
export const EstadoChip = ({ s, testid }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${ST[s]?.[2]}`} data-testid={testid}>
    <span className={`h-2 w-2 rounded-full ${ST[s]?.[1]}`} />{ST[s]?.[0]}</span>
);
export const FlagChip = ({ f, testid }) => (
  <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${FLAG[f.tipo]?.[1]}`} data-testid={testid} title={f.detalle}>{FLAG[f.tipo]?.[0]} · {f.nombre}</span>
);
export const fmtV = (tipo, v) => {
  if (v == null) return "";
  if (tipo === "reciprocidad") return pc(v, 1);
  if (["dscr", "apalancamiento"].includes(tipo)) return xx(v);
  if (tipo === "fondo") return v > 0 ? `${v.toFixed(1)} m atraso` : "al corriente";
  if (["info_trimestral", "info_anual", "manual"].includes(tipo)) return "";
  return money(v);
};
export const mesL = (m) => (m ? new Date(`${m}-15T12:00:00`).toLocaleDateString("es-MX", { month: "short", year: "numeric" }) : "—");
